export default "__VITE_ASSET__483bc28b__"